// extracted by mini-css-extract-plugin
export default {"login":"login_login__BTrGB","loginWrap":"login_loginWrap__-fU-s","signup":"login_signup__UuCUA","updated":"login_updated__Yr9M-"};